// extracted by mini-css-extract-plugin
module.exports = {"search":"CoreSearch_search__9B6UL","searchWrapper":"CoreSearch_searchWrapper__ErMGR","slide-down":"CoreSearch_slide-down__5JZZO","slide-up":"CoreSearch_slide-up__w248N"};